function Footer() {
  return (
    <footer className="sticky-footer bg-white ">
      <div className="container my-auto">
        <div className="text-center my-auto">
          <span>© {new Date().getFullYear()} ATM IAVE-WEB.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
